// @ts-check
/**
 * Typed client for the patient work queue API.
 *
 * TYPES ARE GENERATED, NOT HAND-WRITTEN. See `schema.d.ts` header for details.
 *
 *     npm run generate:types-from-openapi-schema
 */
import axios from 'axios'

/** @typedef {import('./schema').components['schemas']} Schemas */
/** @typedef {Schemas['PatientWorkQueueRequest']} PatientWorkQueueRequest */
/** @typedef {Schemas['PatientWorkQueueResponse']} PatientWorkQueueResponse */
/** @typedef {Schemas['PatientWorkQueueGlance']} PatientWorkQueueGlance */

/**
 * POST /api/patient-work-queue/ — fetch the care management patient work queue.
 * @param {PatientWorkQueueRequest} params
 * @returns {Promise<PatientWorkQueueResponse>}
 */
export async function fetchPatientWorkQueue(params) {
  const { data } = await axios.post('/api/patient-work-queue/', params)
  return data
}

/**
 * GET /api/patient-work-queue/ — day-at-a-glance summary stats.
 * @param {{ member_id?: number, metric_ids?: string }} [params]
 * @returns {Promise<PatientWorkQueueGlance>}
 */
export async function fetchPatientWorkQueueGlance(params) {
  const { data } = await axios.get('/api/patient-work-queue/', { params })
  return data
}
